import { render } from "./OverviewHome.vue?vue&type=template&id=b31b6816&scoped=true"
import script from "./OverviewHome.vue?vue&type=script&lang=js"
export * from "./OverviewHome.vue?vue&type=script&lang=js"

import "./OverviewHome.vue?vue&type=style&index=0&id=b31b6816&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b31b6816"]])

export default __exports__